import React from "react";
import { useHistory } from "react-router-dom";

import { Grid, Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Button from "../../components/Button";
import logo from "../../assets/images/logo.svg";
import expired from "../../assets/images/expired.png";
import Logo from "../../components/Logo";
import Paper from "../../components/Paper";
import Background from "../../components/Background";
import Disclaimer from "../../components/Disclaimer";
import MetaDecorator from "../../components/MetaDecorator";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    img: {
      width: "6rem",
      margin: theme.spacing(4, 0),
    },
  })
);

export default function ExpiredLink() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <MetaDecorator />
      <Background>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={8} lg={3}>
            <Paper>
              <Logo src={logo} />
              <img src={expired} alt="expired" className={classes.img} />
              <Typography variant="h4">Link je istekao.</Typography>
              <Disclaimer>
                Link kojem pokušavate pristupiti je istekao. Kliknite na gumb
                “Ponovno pošalji” kako bismo Vam ponovno poslali link za
                promjenu lozinke.
              </Disclaimer>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                onClick={() => history.push("/reset-lozinke")}
              >
                Ponovno pošalji
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Background>
    </>
  );
}
